__turbopack_context__.v({
  "shotPreviewMarkdown": "index-module__OsT9tq__shotPreviewMarkdown",
  "timeMaker": "index-module__OsT9tq__timeMaker",
});
